<div class='pt-header' data-testid="pt-header">
  <div class='title'>
    <pt-icon [iconType]='IconType.SVG' [key]='headerIconKey' [size]='50' (click)="clickLogo.emit()"></pt-icon>
    <div class='w-100' style="margin-right: 20px">
      <div *ngIf='headerEntityName' class='h3 mb-0 d-flex align-items-baseline'>
        <span class='font-13'>{{ headerEntityName }}</span>
        <button type='button' class='d-inline-flex btn btn-link border-0 btn-sm p-0 ms-2 align-items-center font-14'
                [disabled]="loading"
                aria-label='History'
                (click)='history()'>
          <pt-icon [key]='IconHistory' [size]='iconSize' style="margin-right: 5px;"></pt-icon>
          {{'BUTTON.DOCUMENT_HISTORY' | translate}}
        </button>

        <div class="d-inline-flex align-items-center">
          <ng-content></ng-content>
        </div>
        <button type='button'
                *ngxPermissionsOnly='[PtPermissions.ENABLE_FOR_SYSTEM]'
                class='d-inline-flex btn btn-primary btn-sm ms-auto align-items-center font-14'
                style="width: 155px; text-align: center; justify-content: center;"
                [disabled]="loading"
                aria-label='Completed Dialog'
                (click)='completedDialog()'>
          {{'BUTTON.COMPLETAMENTO' | translate}}
        </button>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <label [innerHTML]='headerTitle' class='font-18'></label>
          <span *ngIf='templateStatusLabel'
                [ngClass]="isDraft ? 'bg-warning text-dark' : 'bg-primary'"
                class='badge rounded-pill ms-1'
                style="height: 15px;"
          >{{ templateStatusLabel }}</span>
          <pt-w-help *ngIf="isDraft" [help]='"MESSAGE.DRAFT" | translate'></pt-w-help>
          <pt-w-help *ngIf="!isDraft" [help]='"MESSAGE.PUBLISHED" | translate'></pt-w-help>
        </div>


        <pt-template-header-action
          [docInfo]="docInfo"
          [availableOperations]="documentPermission"
          [loading]="loading">
        </pt-template-header-action>
      </div>




    </div>
  </div>

</div>
